import { useEffect, useRef, useState } from 'react';
// import { userSidebarData } from '../../../constants/userSidebarData';
import LinkWrapper from './LinkWrapper';
import { useTranslation } from 'react-i18next';
import { useLocation, Link, useParams, useNavigate } from 'react-router-dom';
// import SidebarItemsList from './SidebarItemsList';

// Icons

import {
  dashboard,
  leftArrow,
  rightArrow,
  downArrow,
  programNewIcon,
} from '../../../constants/icons';
import ls from 'localstorage-slim';
// enable global encryption
ls.config.encrypt = true;
function AdminSidebar(props) {
  const { t } = useTranslation();
  const location = useLocation();
  const [sidebarItems, setSidebarItems] = useState([]);
  const { orgId } = useParams();
  const [sidebarActive, setSidebarActive] = useState(false);
  const [moreOptionsActive, setMoreOptionsActive] = useState(false);
  const [language, setLanguage] = useState({});
  const activeRole = JSON.parse(ls.get('activeRole'));
  const { pathname, state } = useLocation();
  const pathSplit = pathname.split('/');
  const [activeMain, setActiveMain] = useState(pathSplit[2]);
  const navigate = useNavigate();
  const isFromDashBoardRef = useRef(true);


  useEffect(() => {
    const sidebar = sidebarItems.map((item) => item.text.toLowerCase());
    if (sidebar.includes(activeMain)) {
      setSidebarActive(true);
    }
  }, [sidebarItems]);

  // for view all programs from dashboard
  useEffect(() => {
    if (pathSplit[2] === 'program') {
      if (state?.from === 'dashboard' && isFromDashBoardRef.current) {
        setActiveMain('program');
        isFromDashBoardRef.current = false;
      }
    } else {
      isFromDashBoardRef.current = true;
    }
  }, [pathSplit]);

  const onItemClick = (index, hasChildren, e) => {
    if (hasChildren) {
      e.preventDefault();
      let sbActive = false;
      const newItems = sidebarItems.map((item, i) => {
        if (i === index) {
          item.isActive = true;
          sbActive = true;
        } else {
          item.isActive = false;
        }
        return item;
      });
      setSidebarItems(newItems);
      setSidebarActive(sbActive);
      setActiveMain(newItems[0].text.toLowerCase());
    }
  };

  const activeSubMenu = (data) => {
    setSidebarActive(true);
    setActiveMain(data);
  };
  const onItemHideClick = (e, path) => {
    e.preventDefault();
    const newItems = sidebarItems.map((item, i) => {
      item.isActive = false;
      return item;
    });
    setSidebarItems(newItems);
    setSidebarActive(false);
    navigate(path);

    setActiveMain(path);
  };
  const hideSubMenu = () => {
    setSidebarActive(false);
  };

  const onMoreOptionsClick = (e) => {
    e.preventDefault();
    setMoreOptionsActive((active) => !active);
  };

  useEffect(() => {
    if (props.data && Array.isArray(props.data) && props.data.length > 0) {
      console.log("Setting sidebar items:", props.data);
      setSidebarItems(props.data);
    }
  }, [props.data]);


  const childMapper = (child, j) => {
    if (child.type === 'divider') {
      return (
        <li
          key={j}
          className="divider"
        />
      );
    }
    const isActivePath = location.pathname === child.link || location.pathname.includes(child.link);

    return (
      <li
        key={j}
        className={isActivePath ? 'active' : ''}
      >
        <LinkWrapper
          isReact={child.isReact}
          href={child.link}
        >
          {child.text}
          {child.children && rightArrow}
        </LinkWrapper>
      </li>
    );
  };

  const listSidebarItems =
    sidebarItems.length > 0 &&
    sidebarItems.map((item, i) => {
      let childItems = null;
      let itemHasChildren = false;
      const isActivePath = location.pathname === item.link || location.pathname.includes(`${item.link}/`);

      if (item.children) {
        itemHasChildren = true;
        const enabledChild = item.children.filter((n) => n.is_enable);
        const moreOptions = enabledChild.filter((n) => n.isMoreOptions);
        const children = enabledChild.filter((n) => !n.isMoreOptions);
        childItems = children.map(childMapper);
        if (moreOptions.length) {
          const moreOptionsList = moreOptions.map(childMapper);
          childItems.push(
            <li
              key={childItems.length}
              className={moreOptionsActive ? 'dropdown-option dropdown-option-active' : 'dropdown-option'}
            >
              <a
                onClick={onMoreOptionsClick}
                href="#top"
              >
                More Options
                {downArrow}
              </a>
              <ul>{moreOptionsList}</ul>
            </li>,
          );
        }
      }

      if (item.type === 'divider') {
        return (
          <li
            key={i}
            className="divider"
          />
        );
      }

      return (
        <li
          key={i}
          className={activeMain === item.text.toLowerCase() ? 'active' : ''}
        >
          <LinkWrapper
            href={item.link}
            isReact={item.isReact}
            onClick={onItemClick.bind(null, i, itemHasChildren)}
            className="is-active"
          >
            <div className="icon-wrap">
              {item.icon}
              <span className="sidebar-hidden-item text-truncate">{t(item.text)}</span>
            </div>
            <div className="sidebar-hidden-item">{item.rightIcon ? item.rightIcon : item.children ? rightArrow : null}</div>
          </LinkWrapper>
          {item.children && (
            <div className="inner-sidebar">
              <div className="fixed-sidebar-back">
                <a
                  className="sidebar-back-nav"
                  onClick={(e) => onItemHideClick(e, item.link)}
                  href="#top"
                >
                  {leftArrow}
                  <span
                    className="text-truncate"
                    title={t(item.text)}
                  >
                    {t(item.text)}
                  </span>
                </a>
                <span className="divider" />
              </div>
              <ul className="inner-sidebar-list">{childItems}</ul>
            </div>
          )}
        </li>
      );
    });

  return (
    <div className={sidebarActive ? 'sidebar sidebar-active' : 'sidebar'}>
      <ul className="sidebar-list">
        <li
          onClick={(e) => onItemHideClick(e, 'dashboard')}
          className={activeMain === 'dashboard' ? 'active' : ''}
        >
          <Link to={`/admin/dashboard/`}>
            <div className="icon-wrap">
              {dashboard}
              <span className="sidebar-hidden-item text-truncate">Dashboard</span>
            </div>
          </Link>
        </li>
        <li
          onClick={(e) => onItemHideClick(e, 'subjects')}
          className={activeMain === 'subjects' ? 'active' : ''}
        >
          <Link to={`/admin/subjects/`}>
            <div className="icon-wrap">
              {programNewIcon}
              <span className="sidebar-hidden-item text-truncate">Subjects</span>
            </div>
          </Link>
        </li>
        <li
          onClick={(e) => onItemHideClick(e, 'topics')}
          className={activeMain === 'topics' ? 'active' : ''}
        >
          <Link to={`/admin/topics/`}>
            <div className="icon-wrap">
              {programNewIcon}
              <span className="sidebar-hidden-item text-truncate">Topics</span>
            </div>
          </Link>
        </li>
        <li
          onClick={(e) => onItemHideClick(e, 'sub-topics')}
          className={activeMain === 'sub-topics' ? 'active' : ''}
        >
          <Link to={`/admin/sub-topics/`}>
            <div className="icon-wrap">
              {programNewIcon}
              <span className="sidebar-hidden-item text-truncate">Sub-Topics</span>
            </div>
          </Link>
        </li>
        {/* <li
          onClick={(e) => onItemHideClick(e, 'question-pool')}
          className={activeMain === 'question-pool' ? 'active' : ''}
        >
          <Link to={`/admin/question-pool/`}>
            <div className="icon-wrap">
              {programNewIcon}
              <span className="sidebar-hidden-item text-truncate">Question pool</span>
            </div>
          </Link>
        </li> */}
        <li
          onClick={(e) => onItemHideClick(e, 'questions')}
          className={activeMain === 'questions' ? 'active' : ''}
        >
          <Link to={`/admin/questions/`}>
            <div className="icon-wrap">
              {programNewIcon}
              <span className="sidebar-hidden-item text-truncate">Questions</span>
            </div>
          </Link>
        </li>
        <li
          onClick={(e) => onItemHideClick(e, 'reports')}
          className={activeMain === 'reports' ? 'active' : ''}
        >
          <Link to={`/admin/reports/`}>
            <div className="icon-wrap">
              {programNewIcon}
              <span className="sidebar-hidden-item text-truncate">Reports</span>
            </div>
          </Link>
        </li>
        {/* <SidebarItemsList
          data={userSidebarData}
          activeMain={activeMain}
          onHide={hideSubMenu}
          name="users"
          onActive={activeSubMenu}
        /> */}
      </ul>
    </div>
  );
}

export default AdminSidebar;
